import {makeAutoObservable, observable, reaction} from 'mobx';
import {localStore} from "./localStore";
import {makePersistable, stopPersisting} from "mobx-persist-store";
import {LOCALE_EN, setAppLocale} from "../locale/i18";

export enum GroupStatementsBy {
    NONE,
    IBAN,
    MONTH
}

class UiState {
    @observable language: string = LOCALE_EN;
    @observable statementTabGroupBy: GroupStatementsBy = GroupStatementsBy.NONE;
    @observable statementTabSelectedGroup: string = "";
    @observable reviewMonthSelected?: string;

    constructor() {
        makeAutoObservable(this);
        makePersistable(this, {
            name: 'uiStateStore',
            properties: ['language', 'statementTabGroupBy', 'statementTabSelectedGroup'],
            storage: localStore
        }).then(() => console.log("UiState hydrated"));
    }

    public stopPersisting = () => {
        stopPersisting(this)
    }
}


export const uiStateStore = new UiState();

setAppLocale(uiStateStore.language)
reaction(
        () => uiStateStore.language,
        setAppLocale
)